module.exports = __webpack_public_path__ + "img/04.9d615f12.jpg";